import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Layout Components
import ClientLayout from '@/components/layout/ClientLayout';
import ProtectedRoute from '@/components/ProtectedRoute';
import PublicRoute from '@/components/PublicRoute';

// Page Components
import LoginPage from '@/pages/LoginPage';
import InvitePage from '@/pages/InvitePage';
import ForgotPasswordPage from '@/pages/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/ResetPasswordPage';
import DashboardPage from '@/pages/DashboardPage';
import ServicesPage from '@/pages/ServicesPage';
import ServiceDetailsPage from '@/pages/ServiceDetailsPage';
import RequestsPage from '@/pages/RequestsPage';
import NewRequestPage from '@/pages/NewRequestPage';
import RequestDetailsPage from '@/pages/RequestDetailsPage';
import ProjectsPage from '@/pages/ProjectsPage';
import ProjectDetailsPage from '@/pages/ProjectDetailsPage';
import InvoicesPage from '@/pages/InvoicesPage';
import InvoiceDetailsPage from '@/pages/InvoiceDetailsPage';
import ChatsPage from '@/pages/ChatsPage';
import ChatDetailsPage from '@/pages/ChatDetailsPage';
import SettingsPage from '@/pages/SettingsPage';
import ProfilePage from '@/pages/ProfilePage';
import InputsPage from '@/pages/InputsPage';
import ProjectInputsPage from '@/pages/ProjectInputsPage';
import PublicInputsPage from '@/pages/PublicInputsPage';
import PublicPayPage from '@/pages/PublicPayPage';
import MagicLinkPage from '@/pages/MagicLinkPage';
// Spec 28 §7.5 (stream abill): client updates
import UpdatesPage from '@/pages/UpdatesPage';
import UpdateDetailsPage from '@/pages/UpdateDetailsPage';

export const AppRoutes: React.FC = () => (
  <Routes>
    {/* Public Routes */}
    <Route
      path="/auth/login"
      element={
        <PublicRoute restricted>
          <LoginPage />
        </PublicRoute>
      }
    />
    <Route path="/login" element={<Navigate to="/auth/login" replace />} />
    <Route
      path="/auth/forgot-password"
      element={
        <PublicRoute restricted>
          <ForgotPasswordPage />
        </PublicRoute>
      }
    />
    {/* Legacy redirect for old /forgot-password links */}
    <Route path="/forgot-password" element={<Navigate to="/auth/forgot-password" replace />} />
    <Route
      path="/auth/reset-password"
      element={
        <PublicRoute restricted>
          <ResetPasswordPage />
        </PublicRoute>
      }
    />
    <Route
      path="/invite"
      element={
        <PublicRoute restricted>
          <InvitePage />
        </PublicRoute>
      }
    />
    <Route
      path="/organization-invite"
      element={
        <PublicRoute restricted>
          <InvitePage />
        </PublicRoute>
      }
    />

    {/* ANS-55: sign-in link from the email (token in the URL fragment; works once, 15 minutes) */}
    <Route path="/auth/magic" element={<MagicLinkPage />} />

    {/* R2-G: public magic-link checklist (no login; the token is the credential) */}
    <Route path="/inputs/:token" element={<PublicInputsPage />} />

    {/* ANS-45: public pay page (no login; the token is the credential, one payment-plan entry) */}
    <Route path="/pay/:token" element={<PublicPayPage />} />

    {/* Protected Routes */}
    <Route
      path="/"
      element={
        <ProtectedRoute>
          <ClientLayout />
        </ProtectedRoute>
      }
    >
      <Route index element={<Navigate to="/dashboard" replace />} />
      <Route path="dashboard" element={<DashboardPage />} />
      <Route path="services" element={<ServicesPage />} />
      <Route path="services/:id" element={<ServiceDetailsPage />} />
      <Route path="requests" element={<RequestsPage />} />
      <Route path="requests/new" element={<NewRequestPage />} />
      <Route path="requests/:id" element={<RequestDetailsPage />} />
      <Route path="projects" element={<ProjectsPage />} />
      <Route path="projects/:id" element={<ProjectDetailsPage />} />
      <Route path="projects/:id/inputs" element={<ProjectInputsPage />} />
      <Route path="inputs" element={<InputsPage />} />
      <Route path="updates" element={<UpdatesPage />} />
      <Route path="updates/:id" element={<UpdateDetailsPage />} />
      <Route path="invoices" element={<InvoicesPage />} />
      <Route path="invoices/:id" element={<InvoiceDetailsPage />} />
      <Route path="chats" element={<ChatsPage />} />
      <Route path="chats/:id" element={<ChatDetailsPage />} />
      <Route path="settings" element={<SettingsPage />} />
      <Route path="profile" element={<ProfilePage />} />
    </Route>

    {/* Catch all route */}
    <Route path="*" element={<Navigate to="/auth/login" replace />} />
  </Routes>
);


